import { Link } from "react-router-dom";
import "../Css/AtYourService.css";
import { FaTruckFast, FaBoxOpen, FaPenNib } from "react-icons/fa6";

const serviceItems = [
    {
        icon: FaTruckFast,
        title: "Free Shipping",
        description:
            "Fast delivery on every order with careful packaging and reliable tracking.",
        link: "/shipping-policy",
    },
    {
        icon: FaBoxOpen,
        title: "Returns and Exchange",
        description:
            "Easy returns and exchange support when you need a different fit or style.",
        link: "/return-policy",
    },
    {
        icon: FaPenNib,
        title: "Book a Private Appointment",
        description:
            "Schedule a one-to-one meeting for a more personal shopping experience.",
        link: "/contact",
    },
];

const AtYourService = () => {
    return (
        <section className="at-your-service-section" aria-labelledby="at-your-service-title">
            <div className="at-your-service-shell">
                <h2 id="at-your-service-title" className="at-your-service-title">At your service</h2>

                <div className="at-your-service-grid">
                    {serviceItems.map(({ icon: Icon, title, description, link }) => (
                        <article key={title} className="at-your-service-card">
                            <Link
                                to={link}
                                key={title}
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                            >
                                <div className="at-your-service-icon-wrap-icon-div">
                                    <div className="at-your-service-icon-wrap" aria-hidden="true">
                                        <Icon />
                                    </div>
                                </div>
                                <h3>{title}</h3>
                                <p>{description}</p>
                            </Link>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AtYourService;